module.exports = __webpack_public_path__ + "Roboto-500.88f29ea5a372d06f5213.ttf";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.ttf
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.ttf
// module chunks = main styles